/* eslint-disable @typescript-eslint/consistent-type-definitions */
import {WidgetComponentType} from './types';

declare global {
  interface Window {
    widgets: {[key: string]: WidgetComponentType};
  }
}

const LOAD_WIDGET_EVENT = 'tmtWidgetLoad' as const;
const LOADER_READY_EVENT = 'tmtWidgetLoaderReady' as const;
const globalReadyProp = `_${LOADER_READY_EVENT}` as const;

function sendEvent(id: string, preserveWidgetProps: boolean) {
  const event = new CustomEvent(LOAD_WIDGET_EVENT, {
    detail: {id, preserveWidgetProps}
  });
  document.dispatchEvent(event);
}

function exposeWidget(id: string, component: WidgetComponentType) {
  if (!('widgets' in window)) {
    // eslint-disable-next-line
    (window as any).widgets = {};
  }
  window.widgets[id] = component;
}

function init(widgetId: string, preserveWidgetProps = false) {
  if (globalReadyProp in window) {
    // widget loader already loaded
    sendEvent(widgetId, preserveWidgetProps);
  } else {
    document.addEventListener(LOADER_READY_EVENT, () => {
      // widget waited for widget loader
      sendEvent(widgetId, preserveWidgetProps);
    });
  }
}

export {exposeWidget, init};
